import React, { Component } from "react";
import { config } from "../../config/config";
import { withAppState, getAppState } from "../../state";
import { autologin } from "../../services/authenticationService";
import { SplashStyled, ContainerStyled, LogoStyled, LoadingStyled } from "./styles/Styled";
import { getSdk } from "../../services/sdkService";
import { checkVoucherEligiblity } from "../../services/eVoucherEligibilityService";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { routes } from "../../routes";
import { showForceLogoutError } from "../../services/modalsService";
import Logo from "../../components/Logo";

// FIXME: Setting timeout to artificially cause the Splash screen to be displayed for a while
// Once we do more stuff during the splash screen, the timer won't be necessary
const TEMPORARY_DELAY = 5000;

class Splash extends Component {
  constructor(props) {
    super(props);
    this.isVoucherActive = null;
    this.checkUserLogged = this.checkUserLogged.bind(this);
    this.setVoucherEligibility = this.setVoucherEligibility.bind(this);
    this.proceedNavigation = this.proceedNavigation.bind(this);
  }

  async componentDidMount() {
    this.props.pauseNavigation();
    await config.get();
    // force logout checks
    if (!!getAppState().forceLogout) {
      this.props.resumeNavigation();
      showForceLogoutError.call(this);
      return;
    }
    this.props.applicationState.appStarted === false && (await this.setVoucherEligibility());
    await this.proceedNavigation();
  }

  componentWillUnmount() {
    this.props.resumeNavigation();
  }

  async proceedNavigation() {
    const {
      history,
      applicationState,
      stateActions: { getHomePath, setAppStartedValue }
    } = this.props;
    let path = !!this.isVoucherActive ? routes.landing : getHomePath();
    // Remove this checkUserLogged as we are already checking in index.js for optimizations
    await this.checkUserLogged();
    !!this.isVoucherActive && setAppStartedValue();

    if (applicationState?.migration_status) {
      path = getHomePath(false, false, applicationState.migration_status);
    }
    setTimeout(() => history.replace(path), TEMPORARY_DELAY);
  }

  async checkUserLogged() {
    const { stateActions, applicationState } = this.props;
    const loggedIn = await autologin();
    if (loggedIn) {
      stateActions.userLoggedIn(loggedIn);
      applicationState.migration_status = loggedIn.settings.migration_status || null;
      applicationState.userName = loggedIn.username;
      const sdk = await getSdk();
      sdk.userManager.getDevices();
      sdk.userManager.getPreferences();
    }
  }

  async setVoucherEligibility() {
    const voucherEligibility = await checkVoucherEligiblity();
    this.isVoucherActive = !!voucherEligibility;
  }

  render() {
    return (
      <SplashStyled>
        <ContainerStyled>
          <LogoStyled>
            <Logo width="20.37vw" height="8.055vh"/>
          </LogoStyled>
          <LoadingStyled />
        </ContainerStyled>
      </SplashStyled>
    );
  }
}

export default withAppState(withSubtheme(Splash));
